import { createActions, createReducer } from 'reduxsauce'

import { AuthenticationTypes } from '../authentication/duckAuthentication'

/* Initial State */
const INITIAL_STATE = {
  error: null
}

/**
 * Creating actions and types with reduxsauce.
 */
const { Types, Creators } = createActions({
  savePersonalInformation: ['personalInformation', 'onSuccess', 'onError'],
  updateUserPassword: ['passwordData', 'onSuccess', 'onError'],

  userError: ['error']
})

const savePersonalInformation = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const updateUserPassword = (state = INITIAL_STATE) => ({
  ...state,
  error: INITIAL_STATE.error
})

const userError = (state = INITIAL_STATE, { error }) => ({
  ...state,
  error
})

const logout = () => ({ ...INITIAL_STATE })


/**
 * Creating reducer with Types.
 */
export default createReducer(INITIAL_STATE, {
  [Types.USER_ERROR]: userError,

  [Types.SAVE_PERSONAL_INFORMATION]: savePersonalInformation,
  [Types.UPDATE_USER_PASSWORD]: updateUserPassword,

  [AuthenticationTypes.LOGOUT]: logout
})

export {
  Types as UserTypes,
  Creators as UserActions
}
